import { connectDependentSelect2Fields, setCookie, removeCookie } from "../utils/fn";

export default () => {
  var $window = $(window),
      $widgets = $('.m1-find-vehicle-us:not(".initialized")');

  $widgets.on('click', '.m1-find-vehicle-us_toggle-button, .m1-find-vehicle-us_toggle-title', function(event) {
    var $btn = $(this),
        $widget = $btn.closest('.m1-find-vehicle-us'),
        $vehicleTypes = $widget.next(),
        isCollapsed = $widget.hasClass('collapsed'),
        $small = $widget.find('.m1-find-vehicle-us_small-wrapper'),
        $big = $widget.find('.m1-find-vehicle-us_big-wrapper');

    $small.stop(true);
    $big.stop(true);
    $vehicleTypes.stop(true);

      if (isCollapsed) {
        $widget.removeClass('collapsed');
  
        $window.trigger('find-vehicle-before-expand');
  
        $small.slideUp(300);
        $big.slideDown(300);
        $vehicleTypes.slideDown(300);
  
        setCookie('find_vehicle_expanded', 1, 365);
      } else {
        $widget.addClass('collapsed');
  
        $small.slideDown(300);
        $big.slideUp(300);
        $vehicleTypes.slideUp(300);
  
        removeCookie('find_vehicle_expanded');
      }
  });

  $widgets.on('click', '.m1-find-vehicle-us_type-switcher input', function() {
    var $widget = $(this).closest('.m1-find-vehicle-us');

    $widget.toggleClass('show-used');
  });

  $widgets.each(function(index, widget) {
    var $widget = $(widget),
        $sections = $widgets.find('section');

    $sections.each(function(index, section) {
      var $section = $(section),
          $form = $section.find('form'),
          formData = $form.data(),
          isSmall = $widget.is('.small'),
          isCollapsed = $widget.hasClass('collapsed'),
          $small = $widget.find('.m1-find-vehicle-us_small-wrapper'),
          $big = $widget.find('.m1-find-vehicle-us_big-wrapper'),
          $vehicleTypes = $widget.next(),
          $cars_form_make = $form.find('.cars_form_make'),
          $cars_form_model = $form.find('.cars_form_model'),
          $cars_form_year = $form.find('.cars_form_year'),
          $cars_form_price = $form.find('.cars_form_price'),
          $cars_form_submit = $form.find('.cars_form_submit');

      if (isSmall) {
        $small.hide();
      } else {
        if (isCollapsed) {
          $big.hide();
          $vehicleTypes.hide();
        } else {
          $small.hide();
        }
      }

      $form.on('submit', function(event) {
        event.preventDefault();

        gtmDataLayer.push({
          event: 'findVehicleSubmit',
        });

        var data = $form.serialize(),
            dataSplit = data.split('&'),
            params = {},
            makeAlias,
            modelAlias,
            href;

        // get rid of empty parameters
        dataSplit = dataSplit.filter(function(param) {
          return param.split('=')[1].length;
        });

        dataSplit.forEach(function(param) {
          var paramSplit = param.split('=');
          params[paramSplit[0]] = paramSplit[1];
        });

        // send to make or model if there is no year and it's OEM form
        if (!params.year && formData.cseType === 'oem') {
          makeAlias = params.make.split('_')[1];
          // go to model make page if no model
          if (params.model && params.model !== '%20') {
            modelAlias = params.model.split('_')[1];
            href = '/' + makeAlias + '/' + modelAlias + '/';
          } else {
            href = '/' + makeAlias + '/';
          }

          window.location.href = href
          
          return;
        }

        dataSplit = dataSplit.map(function(param) {
          var paramSplit = param.split('='),
              val;
          if (paramSplit[1].indexOf('_') !== -1) {
            // if price min-max
            if (paramSplit[0] === 'price-msrp') {
              val = paramSplit[1].split('_').join(',');
            // if make id_alias
            } else {
              val = paramSplit[1].split('_')[0];
            }

          } else {
            val = paramSplit[1];
          }

          return paramSplit[0] + '=' + val;
        });
        
        //if no model -- don't add &model=%20 to end of url
        //data = dataSplit.join('&');
        if (dataSplit[1] == 'model=%20') {
          data = dataSplit[0];
        } else {
          data = dataSplit.join('&');
        }

        window.location.href = $form.attr('action') + (data ? '?with_images=true&' + data : '');
      });

      if (connectDependentSelect2Fields && typeof connectDependentSelect2Fields === 'function') {
        connectDependentSelect2Fields($cars_form_make, $cars_form_model, 'make_id', $cars_form_submit);
        // if (formData.cseType === 'oem') {
        //   fn.connectDependentSelect2Fields($cars_form_model, $cars_form_year, 'model_id', $cars_form_submit);
        // } else {
        //   fn.connectDependentSelect2Fields($cars_form_model, $cars_form_price, 'model_id', $cars_form_submit);
        // }
      }

      $.fn.select2.defaults.set('language', {
        errorLoading: function() {
          return i18n.no_results;
        },
        loadingMore: function() {
          return i18n.loading;
        },
        noResults: function() {
          return i18n.no_results;
        },
        searching: function() {
          return i18n.loading;
        },
      });


      $cars_form_model.select2({
        placeholder: i18n.select_model
      }).on('select2:open', (function(event) {
        setTimeout(function(){ $('.select2-search input').blur()}, 1);
      }));

      // if (formData.cseType === 'oem') {
      //   $cars_form_year.select2({
      //     language: {
      //       errorLoading: function() {
      //         return i18n.no_results;
      //       },
      //       loadingMore: function() {
      //         return i18n.loading;
      //       },
      //       noResults: function() {
      //         return i18n.no_results;
      //       },
      //       searching: function() {
      //         return i18n.loading;
      //       }
      //     }
      //   });
      // } else {
      //   $cars_form_price.select2({
      //     language: {
      //       errorLoading: function() {
      //         return i18n.no_results;
      //       },
      //       loadingMore: function() {
      //         return i18n.loading;
      //       },
      //       noResults: function() {
      //         return i18n.no_results;
      //       },
      //       searching: function() {
      //         return i18n.loading;
      //       }
      //     }
      //   });
      // }
    });

    $widget.addClass('initialized');
  });
};
